<template>
	<div class="asd" >
		<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
		  <el-form-item label="通知标题" width="100">
		    <el-input v-model="formLabelAlign.name" placeholder="请输入通知标题" style="width: 40%"></el-input>
		  </el-form-item>
		  <el-form-item label="通知人员">
		    <el-input v-model="formLabelAlign.region" placeholder="请选择要通知的人员" style="width: 40%"></el-input>
		  </el-form-item>
		  <el-form-item label="通知内容">
		    <el-input v-model="formLabelAlign.type"  type="textarea" placeholder="请输入通知内容（建议150字以内）" style="width: 40%;" ></el-input>
		 </el-form-item>
		</el-form>
		<el-button  type="primary" style="margin-left:78px;width: 100px;font-size:18px;">保 存</el-button>
	</div>
</template>

<script>
	 export default {
    name: '',
    props: [''],
    data () {
      return {
      	 labelPosition: 'left',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        }
      };
    },
    methods: {}
  }
</script>

<style scoped="scoped">
	.asd{
		position: absolute;
		z-index: 2;
		background-color: white;
		height: 81%;
		width: 82.5%;
		text-align: left;
		padding-top: 30px;
		padding-left: 30px;
	}
	
</style>


// WEBPACK FOOTER //
// src/pages/system/SetInfo.vue